import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_DARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {MakeFieldsRequired} from 'util/Types';

import {BaseFilterFormProps} from './FilterFormConstants';
import FilterFormSkeletonNodeLayout from './FilterFormSkeletonNodeLayout';
import FilterKeyDropdown from './FilterKeyDropdown';

interface SecondaryFilterFormSkeletonProps extends BaseFilterFormProps {
  nodeGrid: Array<Array<JSX.Element>>;
  onRemove: () => void;
}

const SecondaryFilterFormSkeleton: React.SFC<SecondaryFilterFormSkeletonProps> = (
  props: MakeFieldsRequired<
    SecondaryFilterFormSkeletonProps,
    'filterGroups' | 'onChangeFilterKey' | 'selectedFilterKey'
  >
): JSX.Element => {
  const filterKeyDropdown = (
    <FilterKeyDropdown
      buttonSize={props.buttonSize}
      filterGroups={props.filterGroups}
      invalidMessage={props.invalidMessage}
      onChangeFilterKey={props.onChangeFilterKey}
      selectedFilterKey={props.selectedFilterKey}
      disabled={props.locked}
    />
  );
  const nodeGridWithFilterKeyDropdown = props.nodeGrid;
  nodeGridWithFilterKeyDropdown[0].unshift(filterKeyDropdown);
  return (
    <div className={css(styles.wrapper)}>
      <span className={css(styles.content)}>
        <FilterFormSkeletonNodeLayout nodeGrid={nodeGridWithFilterKeyDropdown} />
      </span>
      <span>
        <BenchlingIcon
          className={css(styles.removeIcon, props.locked ? styles.disabledIcon : null)}
          icon="close"
          onClick={props.locked ? undefined : props.onRemove}
        />
      </span>
    </div>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    margin: -10,
  },
  removeIcon: {
    color: GRAY_DARK,
    cursor: 'pointer',
    fontSize: 12,
    margin: '9px 2px 9px 9px',
  },
  disabledIcon: {
    cursor: 'not-allowed',
  },
});

export default SecondaryFilterFormSkeleton;
